module.exports = __webpack_public_path__ + "assets/img/钟继华.de1b9a6f.jpg";